module.exports = __webpack_public_path__ + "static/ru-2-b0d00b9549d389af8fa8291ed35e4bb6.png";